import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';
import eco_gesture from '../../../assets/images/eco-gesture.png';
import EcoGestureDialog from './eco-gesture-dialog';
import { updateContract } from '../../../services/contracts.service';
import { AxiosError } from 'axios';
import { ContractUpdateDto } from '../../../services/dtos/contract-update.dto';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import './eco-gesture.scss';
import { ContractDto } from '../../../services/dtos/contract.dto';
import { showAxiosMessageError } from '../../../services/error-message.service';

/**
 * Composant éco-geste
 * @param props Le contrat affiché
 * @constructor
 */
export default function EcoGesture(props: { contract?: ContractDto; handleChangeEcoGesture: any }) {
    //States open et validate
    const [open, setOpen] = React.useState(false);
    const [validate, setValidate] = React.useState(false);

    //SnackBar pour les messages
    const showMessage = useSnackbars();

    //Handler qui gère l'ouverture et la fermeture de la popup "Eco Geste"
    const handleClickOpenClose = () => {
        setOpen(!open);
    };

    //Handler qui permet d'enregistrer la préférence éco-geste de l'abonné
    const handleClickEcoGesture = () => {
        //On passe en mode validate
        setValidate(true);

        //Creation de l'objet permettant de faire un patch
        const contractUpdate: ContractUpdateDto = {
            factureElectronique: !props.contract?.factureElectronique,
        };
        //Si pas d'id alors on ne fait rien
        if (props.contract?.['@id'] !== undefined) {
            //Mise à jour de l'objet contract, seulement pour l'attribut factureElectronique
            updateContract(props.contract?.['@id'], contractUpdate)
                .then(() => {
                    //Changement de l'état de contrat
                    showMessage.successAlert('Votre choix éco-geste a été pris en compte.');
                    props.handleChangeEcoGesture();
                })
                .catch((error: Error | AxiosError) => {
                    showAxiosMessageError(error, showMessage);
                })
                .finally(() => {
                    // Réactivation du bouton après le traitement
                    setValidate(false);
                });
        } else {
            // Réactivation du bouton après le traitement
            setValidate(false);
        }
        //On ferme la popup
        setOpen(false);
    };

    return (
        //Affichage de la vue conditionnée en fonction de la facture électronique
        <>
            <Card className={'ecoGesture-card'}>
                <CardMedia
                    component="img"
                    className={'ecoGesture-img'}
                    src={eco_gesture}
                    alt="Eco-geste"
                    sx={{ width: '35% !important' }}
                />
                <CardContent className={'ecoGesture-content'}>
                    <Typography variant="body1" color="green.main">
                        {props.contract?.factureElectronique
                            ? 'Vous souhaitez recevoir de nouveau vos factures papier par voie postale ? Cliquez sur le bouton "Valider".'
                            : 'Optez pour la facture électronique et choisissez de recevoir vos factures directement dans votre messagerie.'}
                    </Typography>
                </CardContent>
                <CardActionArea
                    data-testid="open-ecoGesture"
                    onClick={handleClickOpenClose}
                    className={'ecoGesture-action'}
                >
                    Valider
                </CardActionArea>
            </Card>
            <EcoGestureDialog
                open={open}
                handleClose={handleClickOpenClose}
                contract={props.contract}
                handleValidate={handleClickEcoGesture}
                validateForm={validate}
            />
        </>
    );
}
